/* eslint-disable no-undef */

import { getSession } from "../contexts/AmplifyContext";

const axios = require("axios");

const authHeader = async() => {
    const session = await getSession();
    const headers = {
        Accept: "application/json",
        "Content-Type": "application/json; charset=UTF-8" 
    };
    headers.Authorization = `Bearer ${session.getIdToken().getJwtToken()}`;
    return headers;
};

class Rest { 
    delete = async(url) =>{
        const headers = await authHeader();
        return axios.delete(url, {
            withCredentials : true,
            headers: headers
        });
    }
    get = async(url) => {
        const headers = await authHeader();
        return axios.get(url, {
            withCredentials : true,
            headers: headers
        });
    }
    getAll = async(urls) => {
        const headers = await authHeader();
        return axios.all(urls, {
            withCredentials : true,
            headers: headers
        });
    }
    post = async(url, content) => {
        const headers = await authHeader();
        return axios.post(url, JSON.stringify(content), {
            withCredentials : true,
            headers: headers,
        });
    }
    put = async(url, content) => {
        const headers = await authHeader();
        return axios.put(url, JSON.stringify(content), {
            withCredentials : true,
            headers: headers,
        });
    }
}
export const isApiErrorDetailInclude = (ex) => { 
    return ex.response && ex.response.data && typeof (ex.response.data) === 'object'
}

export default new Rest();